import {useState} from "react";
import PropTypes from "prop-types";
import {greyishBlue50, greyishBlue100} from "assets/jss/main";

import MappingValueLine from "./components/MappingValueLine";

const fakeRows = [
    {id: 1, sku: "SKU-12345", label: "Bleu marine", optionValue: "couleur", lang: "FR"},
    {id: 2, sku: "SKU-12346", label: "Rouge cerise", optionValue: "couleur", lang: "FR"},
    {id: 3, sku: "SKU-12347", label: "XL", optionValue: "taille", lang: null},
    {id: 4, sku: "SKU-12348", label: "Homme", optionValue: "genre", lang: "FR/EN"},
];

MappingValueList.propTypes = {
    rows: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            sku: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            optionValue: PropTypes.string.isRequired,
            lang: PropTypes.string,
        })
    ),
    onChange: PropTypes.func,
};

function MappingValueList({rows = fakeRows, onChange = (updatedRows) => console.log("rows changed:", updatedRows)}) {
    const [items, setItems] = useState(rows);
    const [selected, setSelected] = useState([]);

    const allChecked = selected.length > 0 && selected.length === items.length;

    const toggleAll = () =>
        setSelected(allChecked ? [] : items.map((r) => r.id));

    const toggleOne = (id) =>
        setSelected((prev) =>
            prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
        );

    const handleOptionValueChange = (id, newOptionValue) => {
        const updated = items.map((item) =>
            item.id === id ? {...item, optionValue: newOptionValue} : item
        );
        setItems(updated);
        onChange(updated);
    };

    return (
        <div style={{
            border: `1px solid ${greyishBlue100}`,
            borderRadius: "12px",
            overflow: "hidden",
            backgroundColor: "#ffffff",
        }}>
            <div style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                padding: "10px 20px",
                borderBottom: `1px solid ${greyishBlue50}`,
                backgroundColor: "#fafafa",
            }}>
                <input
                    type="checkbox"
                    checked={allChecked}
                    onChange={toggleAll}
                    style={{width: "16px", height: "16px", accentColor: "#4338ca", cursor: "pointer"}}
                />
                <span style={{fontSize: "12px", color: "#9ca3af"}}>
                    {selected.length > 0 ? `${selected.length} sélectionné(s)` : "Tout sélectionner"}
                </span>
            </div>

            {items.map((row, index) => (
                <MappingValueLine
                    key={row.id}
                    row={row}
                    checked={selected.includes(row.id)}
                    isLast={index === items.length - 1}
                    onCheck={() => toggleOne(row.id)}
                    onOptionValueChange={handleOptionValueChange}
                    onValidate={(id) => console.log("validate", id)}
                    onEdit={(id) => console.log("edit", id)}
                />
            ))}
        </div>
    );
}

export default MappingValueList;
